import { CustomizationFieldFragment } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

interface CategorySelectorProps {
  customizationFields: CustomizationFieldFragment[]
  value: string | undefined
  error?: string
  onSelectedCategory: (category: string) => void
  onOpenChange: (open: boolean) => void
  mandatory?: boolean
  readonly?: boolean
}

const CategorySelector = ({
  customizationFields,
  value,
  error,
  onSelectedCategory,
  onOpenChange,
  mandatory,
  readonly,
}: CategorySelectorProps) => {
  const categoryOptions = () => {
    const categories = fieldOptions('expense', 'category', customizationFields)
    return categories
      .filter((cat) => !cat.hidden)
      .map((cat) => ({ label: cat.label, value: `${cat.value}` }))
  }

  return (
    <SelectField
      label={i18n.t('expenses_v2.forms.fields.category.label')}
      none={i18n.t('expenses_v2.forms.fields.category.placeholder')}
      options={categoryOptions()}
      value={value}
      onChange={(category) => onSelectedCategory(category)}
      onBlur={() => onOpenChange(false)}
      onFocus={() => onOpenChange(true)}
      error={error}
      mandatory={mandatory}
      readonly={readonly}
    />
  )
}

export default CategorySelector
